import { UploadSimpleIcon } from '@phosphor-icons/react';

import styles from './drop-zone.module.css';

import type { DropZoneProps } from './drop-zone.type';

export const DropZone = ({
  isDragging,
  fileInputRef,
  accept,
  title,
  hint,
  selectFileLabel,
  onDragOver,
  onDragLeave,
  onDrop,
  onFileChange,
}: DropZoneProps) => (
  <div
    className={[styles['drop-zone'], isDragging ? styles['drop-zone--dragging'] : ''].join(' ')}
    onClick={() => fileInputRef.current?.click()}
    onDragOver={onDragOver}
    onDragLeave={onDragLeave}
    onDrop={onDrop}
  >
    <input
      ref={fileInputRef}
      type="file"
      accept={accept}
      className={styles['hidden-file-input']}
      onChange={onFileChange}
    />
    <UploadSimpleIcon size={22} color="#6b7280" weight="regular" />
    <span className={styles.title}>{title}</span>
    <span className={styles.hint}>{hint}</span>
    <span className={styles['select-file-label']}>{selectFileLabel}</span>
  </div>
);
